import { ICostSummaryItem, ILineItem } from '../../CartContext.types';

export const usePlanPaymentHook = (lineItem: ILineItem): ICostSummaryItem => {
    return {
        lineNumber: lineItem.lineNumber,
        itemName: lineItem.planSelection?.planDisplayName ?? '',
        amount: lineItem.planSelection?.linePrice ?? 0,
        type: 'cost'
    };
};
